import {datadogRum} from '@datadog/browser-rum';
import {isApiErrorContext} from '@di-shared/api/di/axiosInstance';
import {RegionType} from '@shared/cci/features/const/environment';

export function initDatadog(region: RegionType) {
  datadogRum.init({
    clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
    applicationId: import.meta.env.VITE_DATADOG_APPLICAITION_ID,
    site: 'datadoghq.com',
    service: 'di-app-fo-fe',
    env: import.meta.env.VITE_PROFILE,
    defaultPrivacyLevel: 'allow',
    version: import.meta.env.CI_COMMIT_TAG,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    allowedTracingUrls: [
      (url) => url.startsWith(window.location.origin),
      (url) => url.startsWith(import.meta.env.VITE_CCI_KR_API_URL),
      (url) => url.startsWith(import.meta.env.VITE_DI_KR_API_URL),
    ],
    beforeSend: (event, context) => {
      if (
        event.type === 'error' &&
        event.error &&
        event.error.message === 'Uncaught "Script error."' &&
        event.error.stack?.includes('undefined @')
      ) {
        return false;
      }
      if (event.type === 'resource' && event.resource?.type === 'xhr' && event.resource?.status_code !== 200 && 'xhr' in context) {
        event.context = {
          ...event.context,
          url: event.resource.url,
          message: context.xhr.response,
        };
      }
      return true;
    },
  });

  datadogRum.setGlobalContextProperty('fe-platform', import.meta.env.VITE_PLATFORM);
  datadogRum.setGlobalContextProperty('fe-region', region);
}

export function getDatadogSessionId() {
  return datadogRum.getInternalContext()?.session_id || '';
}

export function setDatadogGlobalContextProperty(key: string, value: string) {
  datadogRum.setGlobalContextProperty(key, value);
}

export function setDatadogUser(id: string) {
  datadogRum.setUser({id});
}

export function setDatadogError(error: unknown, context?: object) {
  datadogRum.addError(error, context);
}

export function setDatadogUnExpectedError(name: string, error: unknown) {
  try {
    const datadogError = new Error(isApiErrorContext(error) ? JSON.stringify(error) : (error as Error).message);
    datadogError.name = name;
    datadogError.cause = error;
    datadogError.stack = datadogError.message;

    const context = {
      source: name,
      'fe-error-context': isApiErrorContext(error) ? error : (error as Error).stack,
    };

    setDatadogError(datadogError, context);
  } catch (error) {
    console.error('Failed to set Datadog custom error', error);
  }
}
